import { MenuItem } from 'primeng/api';
import {
    buildSidebarMenu,
    findActiveMenuItem,
    getChildItems,
    isMenuItemActive,
    isMenuItemExactActive,
    itemKey,
    menuIcon,
    normalizeRouterLink,
    trackMenuItem
} from './app-menu.utils';

export class AppMenuController {
    items: MenuItem[] = [];
    visibleItems: MenuItem[] = [];
    expandedMenuKeys: Record<string, boolean> = {};
    currentUrl = '/';

    setItems(items: MenuItem[]): void {
        this.items = items;
        this.refresh();
    }

    setCurrentUrl(currentUrl: string): void {
        this.currentUrl = currentUrl;
        this.refresh();
    }

    toggleGroup(item: MenuItem, event?: Event): void {
        event?.preventDefault();
        event?.stopPropagation();

        if (!this.hasChildren(item)) {
            return;
        }

        const key = this.getMenuKey(item);
        this.expandedMenuKeys = {
            ...this.expandedMenuKeys,
            [key]: !this.isExpanded(item)
        };
        this.refresh();
    }

    expandGroup(item: MenuItem): void {
        if (!this.isExpanded(item)) {
            this.toggleGroup(item);
        }
    }

    hasChildren(item: MenuItem): boolean {
        return getChildItems(item).length > 0;
    }

    childItems(item: MenuItem): MenuItem[] {
        return getChildItems(item);
    }

    routerLink(item: MenuItem): string | null {
        return normalizeRouterLink(item.routerLink);
    }

    icon(item: MenuItem): string {
        return menuIcon(item);
    }

    isExpanded(item: MenuItem): boolean {
        return item.expanded === true;
    }

    isActive(item: MenuItem): boolean {
        return isMenuItemActive(item, this.currentUrl);
    }

    isExactActive(item: MenuItem, currentUrl: string = this.currentUrl): boolean {
        return isMenuItemExactActive(item, currentUrl);
    }

    currentPageTitle(): string {
        return findActiveMenuItem(this.items, this.currentUrl)?.label ?? '';
    }

    activeItem(): MenuItem | null {
        return findActiveMenuItem(this.items, this.currentUrl);
    }

    trackItem(index: number, item: MenuItem): string {
        return trackMenuItem(item, index);
    }

    private refresh(): void {
        this.visibleItems = buildSidebarMenu(this.items, '', this.currentUrl, this.expandedMenuKeys);
    }

    private getMenuKey(item: MenuItem): string {
        return item.id ?? itemKey(item);
    }
}
